import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PlatformSidenavService {
  readonly sidenavOpen = signal(true);
  readonly menuState = signal<'main'>('main');

  /**
   * Opens the sidenav on mobile.
   */
  openSidenav(): void {
    this.sidenavOpen.set(true);
  }

  /**
   * Closes the sidenav on mobile.
   */
  closeSidenav(): void {
    this.sidenavOpen.set(false);
  }

  /**
   * Toggles the sidenav open state.
   */
  toggleSidenav(): void {
    this.sidenavOpen.update((value) => !value);
  }
}
